/** Cookie used to remember post-login destination across OAuth redirects (e.g. Google). */
export const HUB_AUTH_NEXT_COOKIE_NAME = "hub_auth_next";

/**
 * Validates a post-login redirect path to prevent open redirects.
 * Only app-relative paths are allowed (optionally with query string), never protocol-relative or absolute URLs.
 */
export function isSafeHubRelativePath(path: string): boolean {
  const t = path.trim();
  if (!t.startsWith("/") || t.startsWith("//")) {
    return false;
  }
  if (t.length > 2048 || t.includes("\n") || t.includes("\r")) {
    return false;
  }
  if (t.includes("://") || t.includes("\\") || t.includes("@")) {
    return false;
  }
  return true;
}

export function pickFirstSafeRedirect(
  candidates: Array<string | null | undefined>
): string | null {
  for (const c of candidates) {
    if (c && isSafeHubRelativePath(c)) {
      return c.trim();
    }
  }
  return null;
}

export function decodeOptionalCookieValue(raw: string | undefined): string | null {
  if (!raw) {
    return null;
  }
  try {
    const decoded = decodeURIComponent(raw);
    return decoded || null;
  } catch {
    return null;
  }
}
